function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React from 'react';

var SearchField = /*#__PURE__*/function (_React$Component) {
  _inherits(SearchField, _React$Component);

  var _super = _createSuper(SearchField);

  function SearchField() {
    _classCallCheck(this, SearchField);

    return _super.apply(this, arguments);
  }

  _createClass(SearchField, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var that = this;
      $('.header-search-field-spot input').autocomplete({
        source: function source(request, response) {
          $.ajax({
            url: "/webservices/search.svc/suggest/".concat($('.header-search-field-spot input').val(), "/").concat($('html').attr('lang')),
            type: 'GET',
            dataType: 'json',
            success: function success(data) {
              response(data.Suggests);
            },
            error: function error(xhr, textStatus, errorThrown) {
              console.log('error search-field-spot ', url);
            }
          });
        },
        select: function select(a, b) {
          var searchString = "?q=".concat(b.item.value);
          window.location = that.props.data.resultPage + searchString;
        },
        open: function open() {
          $('ul.ui-menu').width($('.header-search-field').innerWidth());
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _ref = this.props || [],
          data = _ref.data,
          isDesktop = _ref.isDesktop;

      var query = '';

      var handleSearch = function handleSearch() {
        window.location = "".concat(data.resultPage, "?q=").concat(query);
      };

      var handleKeyUp = function handleKeyUp(event) {
        if (event.key === 'Enter') {
          handleSearch();
        } else {
          query = event.target.value;
        }
      };

      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "component header-search-field-spot",
        "data-restricted-chars": data.restrictedChars
      }, /*#__PURE__*/React.createElement("div", {
        className: "component-content"
      }, /*#__PURE__*/React.createElement("div", {
        className: "header-search-field"
      }, /*#__PURE__*/React.createElement("input", {
        type: "text",
        className: "ui-autocomplete-input",
        autoComplete: "off",
        placeholder: "".concat(isDesktop ? 'Search' : ''),
        onKeyUp: handleKeyUp
      }), /*#__PURE__*/React.createElement("div", {
        className: "search-icon",
        onClick: handleSearch
      })))));
    }
  }]);

  return SearchField;
}(React.Component);

export default SearchField;